import { HelpCircle } from 'lucide-react';
import { useChatwootWidget } from './chatwoot-widget-context';
import { useI18nContext } from '@/i18n/i18n-react';
import { cn } from '@/lib/utils';

export function HelpFab() {
  const { isFabEnabled, isOpen, setIsOpen } = useChatwootWidget();
  const { LL } = useI18nContext();

  return (
    <button
      onClick={() => setIsOpen(true)}
      // 2147482646 = z-index of the chatwoot widget - 1
      className={cn(
        'fixed bottom-4 left-4 z-[2147482646] flex h-14 w-14 items-center justify-center rounded-full bg-muted text-primary shadow-lg transition-all hover:scale-110 focus:outline-none focus:ring-2 focus:ring-muted/80 focus:ring-offset-2 pointer-events-auto hover:bg-primary hover:text-primary-foreground',
        // Hidden = invisible too, so it is out of the tab order and the
        // accessibility tree; visibility flips after the fade-out.
        'transition-[opacity,visibility]',
        'invisible opacity-0 pointer-events-none',
        isFabEnabled && !isOpen && 'visible opacity-1 pointer-events-auto'
      )}
      aria-label={LL.common.help()}
      title={LL.common.help()}
    >
      <HelpCircle className="h-6 w-6" />
    </button>
  );
}
